export default "assets/images/queue-lion-footer-ca83f56b.png";